import { Component,  OnInit,  Input,  Output,  EventEmitter} from '@angular/core';
import { Response } from '@angular/http';

import { Audience } from '../model/audience';
import { AudienceService } from '../services/audience.service';

@Component({
  selector: 'app-audience',
  templateUrl: './audience.component.html',
  styleUrls: ['./audience.component.css']
})
export class AudienceComponent implements OnInit {
  @Input()
  audience: Audience;
  @Input()
  audienceName: string;
  @Output()
  updateAudience = new EventEmitter<string>();
  mailto: string;

  constructor(private service: AudienceService) { }

  ngOnInit() {
  }

  getMailto(): string {
    return this.mailto;
  }

  onUpdate(audienceName: string) {
    this.audience.Name = audienceName;
    this.updateAudience.emit(audienceName);
  }
}



// WEBPACK FOOTER //
// ./src/app/audience/audience.component.ts